// import { createMuiTheme } from 'material-ui/styles';
// import teal from 'material-ui/colors/teal';

// const theme = createMuiTheme({
// 	palette: {
// 		primary: teal,
// 		contrastThreshold: 3,
// 		// Used to shift a color's luminance by approximately
// 		// two indexes within its tonal palette.
// 		// E.g., shift from Red 500 to Red 300 or Red 700.
// 		tonalOffset: 0.2,
// 	}
// });
import { createMuiTheme } from 'material-ui/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#757ce8',
      main: '#0C2340',
      dark: '#002884',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#DC4405',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },
});

export default theme;


// WEBPACK FOOTER //
// ./src/theme/index.js